import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import "./PopUpStyless.css"

const country = process.env.REACT_APP_COUNTRY || "";

const PopUp = ({ show, handleClose, title }) => {
    let formUrl;
    let imageUrl;

    switch(country){
        case "UY":
            imageUrl = `${process.env.PUBLIC_URL}/imagenes/Popups/PopUpUY.png`;
            formUrl = "https://forms.office.com/pages/responsepage.aspx?id=2qwNnw-plE6AL1RPBaVfBkVyRCGup4NEvO14EDVK50BUMTA4OFdYUEhKWTJJOFBCNjZGOVJDTjY5TS4u&origin=lprLink&route=shorturl";
            break;
        case "ARG":
            imageUrl = `${process.env.PUBLIC_URL}/imagenes/Popups/PoPuPEXPO2.jpg`;
            formUrl = "https://expo.solutionbox.com.ar";
            break;
        case "PY":
            imageUrl = `${process.env.PUBLIC_URL}/imagenes/Popups/PopUpPy.jpg`;
            formUrl = "https://forms.office.com/r/szcVP4zjxz?origin=lprLink";
            break;
        case "CL":
            imageUrl = `${process.env.PUBLIC_URL}/imagenes/Popups/PopUpCL.jpg`;
            formUrl = "mailto:catalina_molins@solutionbox.cl"
            break;
        case "SV":
            imageUrl = `${process.env.PUBLIC_URL}/imagenes/Popups/PopUpExpoSalvador202606.jpg`;
            formUrl = "https://expo.solutionbox.com.sv"
            break;
        case "HN":
            imageUrl = `${process.env.PUBLIC_URL}/imagenes/Popups/PopUpExpoHonduras202606.jpg`;
            formUrl = "https://expo.solutionbox.com.hn"
            break;   
        default:
          imageUrl = "";
          formUrl = "";  
    }
    

    const handleImageClick = () => {
        window.open(formUrl, '_blank');
    };

    const handleVisitClick = () => {
        handleClose();
        handleImageClick();
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            dialogClassName="custom-modal"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header closeButton className="custom-modal-header">
                <Modal.Title className="custom-modal-title">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0 custom-modal-body">
                <img
                    src={imageUrl}
                    alt="Banner"
                    className="img-fluid w-100"
                    style={{ cursor: 'pointer', display: 'block' }}
                    onClick={handleImageClick}
                />
            </Modal.Body>
            <Modal.Footer className={`custom-modal-footer ${country === "ARG" ? "d-flex justify-content-center" : ""}`}>
                <Button
                    variant="danger"
                    onClick={handleVisitClick}
                    className="custom-modal-button"
                >
                    {country === "ARG" ? "REGÍSTRESE AQUÍ" : "Ver"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PopUp;